export function renderLogs(el: HTMLElement): void {
  el.innerHTML = `<h1>Logs</h1>
    <div class="empty">
      Логи пишутся в Mongo capped collection <code>errors</code>.
      Эндпоинт <code>GET /api/admin/errors</code> можно добавить позже,
      пока — смотри stdout сервисов или Mongo напрямую:
      <pre style="text-align:left;display:inline-block;margin-top:12px">db.errors.find().sort({at:-1}).limit(50)</pre>
    </div>`;
}
